<div *transloco="let t; read: 'formFieldSchedule'" class="schedule-mat-input-root">
  <table class="schedule-mat-input-table">
    <tr class="schedule-mat-input-row">
      <th></th>
      <th *ngFor="let slotColumn of slots" class="schedule-mat-input-hours">
        {{ slotColumn | crmScheduleTime : minutesStep }}
      </th>
    </tr>
    <tr *ngFor="let day of daysOfWeekTranslateKeys" class="schedule-mat-input-row">
      <th>{{ t(indexPerDayTranslateKey[day]) }}</th>
      <td
        *ngFor="let slot of slots"
        class="schedule-mat-input"
        [class.schedule-mat-input_selected]="_toggledSlotsMap.get(day)?.get(slot) != null"
        [class.schedule-mat-input_selected--normal]="_toggledSlotsMap.get(day)?.get(slot) === 'normal'"
        [class.schedule-mat-input_selected--low]="_toggledSlotsMap.get(day)?.get(slot) === 'low'"
        (mouseenter)="onHover(day, slot)"
        (mousedown)="onDown(day, slot)"
      >
        <div
          *ngIf="this.unavailableSlotsByDayTime?.[day]?.[slot] as events"
          class="types"
          dsTooltip
          dsTooltipSize="s"
          [dsTooltipContentRef]="tooltipContent"
          [dsTooltipContentRefContext]="{ events: events }"
        >
          <div
            *ngFor="let event of events"
            class="type"
            [class.color-green]="['f2f', 'course'].includes(event.type)"
            [class.color-pink]="event.type === 'group'"
            [class.color-orange]="event.type === 'webinar'"
          ></div>
        </div>
      </td>
    </tr>
  </table>

  <div class="legend">
    <div class="legend-type">
      <div class="circle color-blue"></div>
      <div class="legend-type-title">{{ t('eventTypes.selected') }}</div>
    </div>
    <div class="legend-type">
      <div class="circle color-light-green"></div>
      <div class="legend-type-title">{{ t('eventTypes.selectedLow') }}</div>
    </div>
    <div class="legend-type">
      <div class="circle color-green"></div>
      <div class="legend-type-title">{{ t('eventTypes.f2f') }}</div>
    </div>
    <div class="legend-type">
      <div class="circle color-pink"></div>
      <div class="legend-type-title">{{ t('eventTypes.group') }}</div>
    </div>
    <div class="legend-type">
      <div class="circle color-orange"></div>
      <div class="legend-type-title">{{ t('eventTypes.webinar') }}</div>
    </div>
  </div>

  <mat-button-toggle-group
    name="priority"
    (change)="priorityChange($event)"
    [value]="priority"
    class="schedule-mat-input-priority"
  >
    <mat-button-toggle value="normal" class="schedule-mat-input-priority--normal">
      {{ t('commonPriority') }}
    </mat-button-toggle>
    <mat-button-toggle value="low" class="schedule-mat-input-priority--low">{{ t('lowPriority') }}</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<ng-template #tooltipContent let-events="events">
  <div class="tooltip-list">
    <div *ngFor="let event of events" class="tooltip-list-item">
      <div
        class="circle"
        [class.color-green]="['f2f', 'course'].includes(event.type)"
        [class.color-pink]="event.type === 'group'"
        [class.color-orange]="event.type === 'webinar'"
      ></div>
      <div class="tooltip-stk">{{ event.serviceTypeKey | stk }}</div>
      <div class="tooltip-date">{{ event.dateFrom }}-{{ event.dateTo }}</div>
    </div>
  </div>
</ng-template>
